<template>
    <v-form v-model="isFormValid" ref="emailUserReplacementForm" lazy-validation>
        <v-card>
            <v-card-title>Bulk Primary Contact Replacement</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="3">
                        <v-select :items="userList" v-model="replacement.currentUser" label="Current User" :rules="[v=>!!v || 'Current User is required']" required>
                            <template #label>Current User <span class="red--text"><strong>*</strong></span></template>
                        </v-select>
                    </v-col>
                    <v-col cols="3">
                        <v-combobox :items="userList" 
                            v-model="replacement.replacementUsers" 
                            :rules="[v=>!!v || 'New User is required']" require
                            @change="onNewUserChange"
                            multiple
                            >
                            <template #label>New User(s) <span class="red--text"><strong>*</strong></span> </template>
                        </v-combobox>
                        <v-dialog v-model="newUser.isNewUserDialogVisible" persistent>
                            <NewUser :userName="newUser.userName" @saved="onNewUserSaved" @canceled="onNewUserCanceled"></NewUser>
                        </v-dialog>
                    </v-col>
                    <v-col cols="2">
                        <!--
                            <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <a target="_blank" class="ma-2" @click="onAddingNewUser">
                                    <v-icon color="primary" v-bind="attrs" v-on="on" >mdi-account-plus</v-icon>
                                </a>
                            </template>
                            <span>Add new user</span>
                        </v-tooltip>
                        -->
                        
                        <v-btn color="success" class="ma-2" @click="onConfirmingSave">
                            <v-icon>mdi-content-save</v-icon>
                            Replace User
                        </v-btn>
                        <ConfirmationPanel :isVisible="isConfirmVisible" :message="confirmMessage" @confirm:click="onConfirmedSave" ></ConfirmationPanel>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-form>
</template>
<script>
    import userAPI from '@/services/userservice';
    export default
    {
        
        name:'EmailPrimaryReplacement',
        data:function()
        {
            return {
                userList:[],
                replacement:{
                    currentUser:null,
                    replacementUsers: []
                },
                isFormValid:false,
                isConfirmVisible: false,
                confirmMessage:'',
                newUser:{
                    isNewUserDialogVisible:false,
                    userName:''
                }
                
            }
        },
        methods:{
            async loadUsers(){
                await userAPI.getUsers()
                .then(response=>{
                    response.data.map((user)=>{
                        this.userList.push({value:user.userId, text: user.name});
                    })
                })
                .catch(error=>{
                    console.log(error);
                })
            },
            async onNewUserChange(newUser)
            {
                if(typeof(newUser)==='string' && newUser.trim())
                {   
                    var value=newUser;
                    console.log('value', newUser);
                    this.newUser.userName=value;
                    const item=this.userList.find(user=>user.value===value);
                    if(item){
                        this.userChanging.newUsers={value:item.value, text: item.text };     
                    } else{ 
                        this.newUser.isNewUserDialogVisible=true;   
                    }
                }   
            },
            async onAddingNewUser(){
                this.newUser.isNewUserDialogVisible=true;
            },
            async onNewUserSaved(isSuccessfull,message,newUser){
                if(isSuccessfull)
                {
                    console.log(message);
                    await this.loadUsers();
                    this.replacement.newUser={value: newUser.userId, text: newUser.name};
                }
                this.newUser.isNewUserDialogVisible=false;

            },
            async onNewUserCanceled(value){
                this.newUser.isNewUserDialogVisible=value;
            },
            async onConfirmingSave()
            {
                this.isFormValid=this.$refs.emailUserReplacementForm.validate();
                if(this.replacement.replacementUsers.length<1)
                {
                    this.$emit('PrimaryReplacement:click',false,`New users are required.`);
                    return;
                }
                if(this.isFormValid  )
                {   
                    this.confirmMessage="Email Primary Contact Confirmation";
                    this.isConfirmVisible=true;
                    console.log('this.isConfirmVisible',this.isConfirmVisible);
                }
                
            },
            async onConfirmedSave(value)
            {
                if(value)
                {
                    await this.onSaving();
                }
                
                this.isConfirmVisible=false;

            },
            async onSaving()
            {
                let newUsers=[];
                    this.replacement.replacementUsers.map((user)=>{
                        newUsers.push(user.value);
                    });
                const user={currentUser: this.replacement.currentUser, replacementUsers: newUsers};
                await userAPI.MailingContactReplacement(user)
                .then(response=>{
                    let message=`User ${this.replacement.currentUser} has been replaced on ${response} devices.`;
                    this.$emit('PrimaryReplacement:click',true,message);
                })
                .catch(()=>{
                    
                    this.$emit('PrimaryReplacement:click',false,`User ${this.replacement.currentUser} could not be replace.` );
                });
            }

        },
        mounted:async function(){
            await this.loadUsers();
        },
        components:{
            NewUser: ()=> import('./NewUser'),
            ConfirmationPanel: ()=> import('@/views/commond/ConfirmationPanel')
        }
    }
</script>